import React from 'react'
import { Button, ButtonProps } from '@mui/material'
import { DeleteSweep } from '@mui/icons-material'

export type KiddomButtonProps = {
  size?: 'small' | 'medium'
  ['data-testid']?: string
} & Pick<ButtonProps, 'onClick' | 'children' | 'disabled' | 'color'>

export function FilledInButton({
  children,
  disabled,
  onClick,
  size = 'medium',
  color = 'primary',
  ...rest
}: KiddomButtonProps) {
  return (
    <Button
      disabled={disabled}
      variant="contained"
      color={color}
      size={size}
      onClick={onClick}
      data-testid={rest['data-testid']}
    >
      {children}
    </Button>
  )
}

export function OutlinedButton({
  children,
  onClick,
  size = 'medium',
  disabled,
  ...rest
}: KiddomButtonProps) {
  return (
    <Button
      variant="outlined"
      disabled={disabled}
      size={size}
      onClick={onClick}
      data-testid={rest['data-testid']}
    >
      {children}
    </Button>
  )
}

export function DeleteButton({
  children,
  onClick,
  size = 'medium',
  disabled,
}: KiddomButtonProps) {
  return (
    <Button
      startIcon={<DeleteSweep />}
      color="warning"
      variant="contained"
      disabled={disabled}
      size={size}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}
